import { useEffect, useState } from 'react'

interface WindowSizeProps {
  windowWidth: number | undefined
  windowHeight: number | undefined
}
export const useWindowResize = () => {
  const [windowSize, setWindowSize] = useState<WindowSizeProps>({
    windowWidth: undefined,
    windowHeight: undefined,
  })

  const handleResize = () => {
    setWindowSize({
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
    })
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    handleResize()
    return () => window.removeEventListener('resize', handleResize)
  }, [])
  return windowSize
}
